<template>
  <div class="Preloader">
    <div class="Preloader__first"></div>
    <div class="Preloader__secont"></div>
    <div class="Preloader__third"></div>
  </div>
</template>

<script>
export default {
  name: 'Preloader'
}
</script>

<style lang="scss" scoped>
.Preloader {
  width: 60px;
  height: 60px;
  margin: auto;
  position: relative;
  display: block;

  &__first,
  &__secont,
  &__third {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 50%;
    border: 6px solid transparent;
  }

  &__first {
    border-top-color: #222;
    border-right-color: #222;
    z-index: 3;
    animation: first 1000ms ease infinite;
  }

  @keyframes first {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  &__secont {
    border-top-color: #868686;
    border-right-color: #868686;
    z-index: 2;
    animation: secont 1000ms ease 150ms infinite;
  }

  @keyframes secont {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  &__third {
    border-top-color: #e7e9eb;
    border-right-color: #e7e9eb;
    z-index: 1;
    animation: third 1000ms ease 350ms infinite;
  }

  @keyframes third {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Preloader/Preloader.vue